const categories = [
  {
    id: 0,
    name: 'Select Category',
    disabled: true
  }
];

export default categories;
